import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import PurchaseDashboardService from "../../services/dashboard/PurchaseDashboardService";
import useApiErrorHandler from "../useApiErrorHandler";
// import useLoading from "../useLoading";
import { clearStats, setStats } from "../../store/slices/dashboard/purchaseDashboardSlice";

const usePurchaseDashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();
  // const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  // Estado desde Redux
  const { stats } = useSelector((state: RootState) => state.purchaseDashboard);

  const fetchStats = async () => {
    try {
      // showLoadingIndicator();
      const response = await PurchaseDashboardService.getStats();
      if (response?.statusCode === 200) {
        const { data } = response;
        dispatch(setStats(data));
        // 🔥 Ya no abrimos ningún modal aquí
      }
    } catch (error: any) {
      handle(error);
    } finally {
      // hideLoadingIndicator();
    }
  };

  const resetStats = () => {
    dispatch(clearStats());
  };

  return {
    stats,
    fetchStats,
    resetStats,
  };
};

export default usePurchaseDashboard;
